import { Component } from "@angular/core";

@Component({
    selector: "ifp-init-mobile",
    template: "",
    standalone: false
})
export class InitMobileComponent {}
